<template>
  <v-layout
    v-if="loading"
    column
    align-center
    justify-center
    style="margin-top: 20vh"
  >
    <v-progress-circular
      :size="70"
      :width="7"
      color="primary"
      indeterminate
    ></v-progress-circular>
    <br />
    <div class="mt-2">Menyiapakan Data</div>
  </v-layout>
  <v-container fluid v-else>
    <div class="headline-container">
      <v-row>
        <v-col cols="12" md="6">
          <span class="headline">Surat Keluar</span>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="6" md="2">
          <v-btn
            width="100%"
            rounded
            color="default"
            class="mr-4"
            @click="$refs.laporan.show()"
          >
            <v-icon left color="primary" class="hidden-sm-and-down">
              mdi-printer
            </v-icon>
            CETAK LAPORAN
          </v-btn>
        </v-col>
        <v-col cols="6" md="2" v-if="hasPrivateAccess">
          <v-btn
            width="100%"
            rounded
            color="primary"
            @click="$refs.formSurat.show()"
          >
            <v-icon left class="hidden-sm-and-down">
              mdi-pencil
            </v-icon>
            INPUT SURAT
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <v-layout row>
      <v-flex id="t">
        <v-card class="pa-0 ml-2" height="100%">
          <v-card-text class="pa-0">
            <v-container grid-list-md>
              <surat-keluar-list
                ref="suratKeluarList"
                @handle-snackbar="emitSnackBar"
                @edit-surat="editSurat"
              />
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <Laporan ref="laporan" />
    <SuratKeluarForm
      ref="formSurat"
      @submited="onFormSubmited"
      @handle-snackbar="emitSnackBar"
    />
  </v-container>
</template>

<script>
import SuratKeluarList from '@/components/SuratKeluar/List'
import SuratKeluarForm from '@/components/SuratKeluar/Form'
import Laporan from '@/components/SuratKeluar/Laporan'
import { mapGetters } from 'vuex'

export default {
  components: {
    SuratKeluarList,
    SuratKeluarForm,
    Laporan
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters(['hasPrivateAccess']),
    yearInteger() {
      return parseInt(this.selectedYear)
    },
    monthInteger() {
      return parseInt(this.selectedMonth)
    }
  },
  mounted() {
    this.$store.dispatch('loadBidang')
  },
  methods: {
    emitSnackBar(text, color) {
      this.$emit('handle-snackbar', text, color)
    },
    onFormSubmited(isEdit = false) {
      this.$refs.suratKeluarList.loadData(isEdit ? undefined : 1)
    },
    editSurat(data) {
      this.$refs.formSurat.show(data)
    }
  }
}
</script>

<style></style>
